import {CategoryProductGridDefinition} from './categoryProductGrid'

export {CategoryProductGridDefinition}
